<template>
	<modal :value="duplicateTemplateModal" effect="fade" :large="true" @cancel="toggleUntoggleDuplicateModal()" @ok="duplicate(templateIdToDuplicate)" cancel-text="Annuler" ok-text="Ok">
		<div slot="modal-header" class="modal-header">
			<h4 class="modal-title">
				<b>Dupliquer une grille d'audit</b>
			</h4>
		</div>
		<div class="form-group">
			<label>Grille du thème à dupliquer : {{ templateLabelToDuplicate }}</label>
			<typeahead
			placeholder="Choisir le thème à associer"
			:data="typeaheadData"
			:template="typeaheadTemplate"
			:on-hit="themeCallback"
			v-model="typeaheadBuffer"
			></typeahead>
		</div>
	</modal>
</template>

<script>
	import { modal as Modal, dropdown as Dropdown, typeahead as Typeahead } from 'vue-strap';
	import axios from 'axios';
	import qs from 'qs'

	export default {
		components: {
			Modal,
			Typeahead,
			Dropdown
		},
		computed: {
			duplicateTemplateModal: function()	{
				return this.$store.state.admin.modalDuplicateTemplate;
			},
			templateIdToDuplicate: function() {
				return this.$store.state.admin.templateIdToDuplicate;
			},
			templateLabelToDuplicate: function() {
				return this.$store.state.admin.templateLabelToDuplicate;
			},
			title: {
				get() {
					return this.$store.state.admin.currentTemplate.title;
				},
				set(value) {
					this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'title', templateData: value});
				}
			},
            typeaheadData: function()   {
                return this.typeaheadDefaultData.filter(item => item.name.toLowerCase().includes(this.typeaheadBuffer));
            }
		},
		methods: {
			toggleUntoggleDuplicateModal()	{
				this.typeaheadBuffer = "";
				this.$store.commit('DISPLAY_MODAL_DUPLICATE_TEMPLATE', !this.duplicateTemplateModal);
			},
			duplicate(templateId) {
				let successCallback = () => {
					this.toggleUntoggleDuplicateModal();
					this.$store.dispatch('getTemplateList', {callbacks: {
                        success: (data) => {
                            this.$store.commit("INIT_TEMPLATE_LIST", data);
                            this.$store.commit('ALERT_DATA_UPDATED', {
                                text: 'Le thème a été dupliqué avec succès.',
                                type: 'success'
                            });
                        }
                    }});
                    this.getTargetTemplates();
				};

				this.$store.dispatch('duplicateTemplate', {
					templateId: templateId,
					targetId: this.$store.state.admin.currentTemplate.targetId,
					callbacks: {
						success: successCallback,
						fail: this.toggleUntoggleDuplicateModal,
						error: this.toggleUntoggleDuplicateModal
					}
				});
			},
			themeCallback(item) {
				this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'title', templateData: item.name});
				this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'targetId', templateData: item.id});
				return item.name;
			},
            getTargetTemplates() {
                let successCallback = (data) => {
                    this.typeaheadDefaultData = data;
                };

                this.$store.dispatch('getTargetTemplates', {
                    onlyEnabled: true,
                    callbacks: {success: successCallback}
                });
            }

		},
		data: function() {
			return {
				typeaheadTemplate: "{{ item.name }}",
                typeaheadDefaultData: [],
                typeaheadBuffer: ""
			}
		},
        beforeCreate()  {
            let successCallback = (data) => {
                this.typeaheadDefaultData = data;
            };

            this.$store.dispatch('getTargetTemplates', {
                onlyEnabled: true,
                callbacks: {success: successCallback}
            });
        }
	};
</script>

<style>
    /* Enlarge typeahead dropdown for theme selection */
    .modal .dropdown-menu {
        min-width: 600px;
        max-width: 800px;
    }

    .modal .dropdown-menu > li > a {
        white-space: normal;
        word-wrap: break-word;
    }
</style>
